<template>
  <div class="terms">
    <el-dialog
      width=50vw
      height=80%
      class="dialog"
      :visible.sync="dialogVisible"
      :close-on-click-modal='false'
      :show-close='false'
      custom-class="termsDialog"
      :modal-append-to-body='false'
    >
    <!-- :modal-append-to-body='false' 解決在 AppSidebar 被 mask 擋住不能按的問題 -->
      <span slot="title" class="dialog-title">
      </span>
      <div class='termsContent'>
        <p><strong>QuickPlan AI</strong><strong>受眾觸及規劃師《使用者條款</strong><strong>》</strong></p>
        <p>歡迎您來到 QuickPlan AI受眾觸及規劃師 (以下稱「QuickPlan」或本服務)，本網站由果實夥伴股份有限公司(下稱本公司)負責經營，所有關於本網站之服務均依據本服務條款所提供。</p>
        <p><u>同意條款</u></p>
        <p>使用 QuickPlan 提供之服務前，煩請詳細閱讀並瞭解本服務條款內容，如有不明處，請立即聯絡本公司。若使⽤者表⽰同意或確認，即能使⽤ QuickPlan 提供之服務，若使⽤者不同意本條款，即無法享受 QuickPlan 服務。</p>
        <p><u>條款修改</u></p>
        <p>QuickPlan 在法律准許的範圍內，有權隨時修改本條款⽂本中的任何條款。⼀旦 QuickPlan 對本條款進⾏修改，QuickPlan 將會以公告形式發佈通知。任何修改將於發佈之時起⽣效。如果使⽤者在修改發佈後，繼續使⽤ QuickPlan 所提供的所有服務，則表⽰同意遵守對本條款所作出的該等修改。因此，請使⽤者務必定期查閱本條款，以確保了解所有關於本條款的最新修改。如果使⽤者不同意 QuickPlan 對本條款進⾏的修改，請登出 QuickPlan 網站並⽴即停⽌使⽤ QuickPlan 服務。同時，使用者應聯絡本公司申請使用資格註銷，QuickPlan 亦有權刪除使用者之帳號資訊並註銷使用資格。</p>
        <p><u>使用者帳號、密碼及安全</u></p>
        <p>使⽤ QuickPlan 的服務之前，必須要註冊並成為使用者。本公司保留帳號申請審核權。註冊成為使用者的過程中，應提供即時、詳盡、準確的個⼈資料，並不斷更新註冊資料，符合即時、詳盡、準確的要求。 所有原始鍵⼊的資料將引⽤為註冊資料。如發⽣註冊不完整或不真實的情況，此情況視為違反使用條款，本公司有權利終⽌對使⽤者的服務。本公司不對任何因註冊信息不真實⽽引起的問題、以及問題發⽣所帶來的後果承擔責任。</p>
        <p>使⽤者不應將其帳號、密碼轉讓或出借給他⼈使⽤，如使⽤者發現其帳號遭他⼈⾮法使⽤， 應⽴即通知本公司。因駭客⾏為或使⽤者的保管疏忽導致帳號、密碼遭他⼈⾮法使⽤，本公司不承擔任何責任。</p>
        <p><u>隱私權政策</u></p>
        <p>使用者提供的註冊信息及 QuickPlan 保留的有關使⽤者的若干其它資料將受到中華⺠國有關個人資料的法律和本公司《隱私權政策》之規範。</p>
        <p><u>使</u><u>⽤</u><u>規定和條約</u></p>
        <p>任何經由 QuickPlan 平台上取得之資訊，未經本公司同意，不得進⾏張貼於對不特定多數人之公開宣傳品 (例如：官網、宣傳製作物&hellip;等等) 或其他與促進本公司商業利益無關之使用，本公司不為任何違規或違法使用內容所造成的損失負責。且本公司有權⽴即停⽌任何前述違規或違法使用之內容並採取相應⾏動， 包括但不限於暫停使⽤者使⽤本服務、註銷使⽤者資格，保存有關記錄，甚⾄採取法律⾏動。</p>
        <p><u>終</u><u>⽌</u><u>服務</u></p>
        <p>使⽤者需同意 QuickPlan可基於其⾃⾏之考慮以及任何理由，包含但不限於缺乏使⽤，或 QuickPlan 認為已經違反本服務條款或中華民國相關法律等，而對使⽤者採取終⽌密碼、帳號、本服務之使⽤或註銷使⽤者資格等方式。QuickPlan 亦可以基於⾃⾝考慮，在法律准許範圍內，於通知或未通知之情形下，隨時終⽌本服務或其任何部分。 使⽤者需同意依本服務條款任何規定提供之本服務，無需進⾏事先通知即可中斷或終⽌。使⽤者承認並同意，QuickPlan 可⽴即關閉或註銷使⽤者的帳號。此外，使⽤者同意若本服務之使⽤被中斷或終⽌帳號及相關信息或存檔被關閉或刪除，QuickPlan 對使⽤者或任何第三⼈均不承擔任何責任或義務。</p>
        <p><u>賠償</u></p>
        <p>使⽤者通過本服務提供、張貼或傳送之內容，有不當使用情形或違反本服務條款及中華民國相關法律因⽽衍⽣或導致任何第三⼈對本公司提出任何索賠或請求，使⽤者應負責賠償本公司一切損失(包括但不限於合理的律師費)。</p>
        <p><u>服務之修改</u></p>
        <p>QuickPlan 有權於任何時間，在法律許可之範圍內，暫時或永久修改或終⽌本服務之一部或全部，⽽無論其通知與否。使⽤者應隨時為資料備份，QuickPlan 不對任何內容丟失以及使⽤者因此⽽遭受的相關損失承擔責任或義務。使⽤者同意對於本服務所作的任何修改、暫停或終⽌， QuickPlan 對使⽤者和任何第三⼈均無需承擔任何責任或義務。</p>
        <p><u>無保證聲明</u></p>
        <p>使用者同意並了解QuickPlan不保證以下事項：</p>
        <ul>
        <li>本服務將不受干擾、及時提供、安全可靠或不會出錯。</li>
        <li>使⽤本服務取得之結果正確可靠。</li>
        <li>經由本服務取得之任何資訊或其它信息將符合使⽤者的期望，且軟體中任何錯誤都將即時得到更正。</li>
        </ul>
        <p>使⽤者⾃ QuickPlan 或經由本服務取得的任何建議或資訊僅為參考，除⾮本服務條款有明確規定，均不構成任何保證。</p>
        <p><u>⼀</u><u>般性條款</u></p>
        <p>本服務條款及使⽤者與 QuickPlan 之關係，均以中華⺠國法律為準據法。使⽤者與 QuickPlan 提供之服務、本服務條款或其它有關事項發⽣的爭議，應以台灣台北地⽅法院為第⼀審管轄法院。QuickPlan 未⾏使或執⾏本服務條款任何權利或規定，不構成對前述權利或權利之放棄。 倘本服務條款之部分規定因與中華⺠國法律抵觸⽽無效者，本服務條款其它規定仍應具有完整的效⼒及效果。本服務條款之標題僅供⽅便⽽設，不具任何法律或契約效果。</p>
        <p><u>舉報</u></p>
        <p>倘發現任何違反本服務條款之情事，請通知本公司。</p>
        <p><u>聯絡我們</u></p>
        <p>如果對本服務條款或我們的信息處理⽅法有任何疑問，請通過電⼦郵件的⽅式聯繫：QuickPlan＠onead.com.tw</p>
        <p><strong>QuickPlan AI</strong><strong>受眾觸及規劃師《隱私權政策</strong><strong>》</strong></p>
        <p>此隱私政策描述QuickPlan所收集的信息，該信息將被如何使用， 以及您對於信息使用和披露可做出的選擇。我們建議您在使用我們的網站和服務以及與我們進行交易時仔細閱讀此隱私政策， 與我們的使用者條款。通過使用我們的網站，即表明您已接受此隱私政策中描述的行為。</p>
        <p><u>個人資料蒐集</u></p>
        <ul>
        <li>當您使用本平台時：本公司會保留您在操作或瀏覽時，於伺服器產生的相關記錄，包括您使用連線設備的IP位址、使用時間、cookies、使用的瀏覽器、瀏覽及點選記錄等。</li>
        <li>當您註冊使⽤者時：我們會收集您的姓名、電子信箱、手機號碼，而在您註冊成為使用者或登入服務後，會運用以上個人資訊作為傳送平台更新服務、活動、快訊等等相關訊息之用途。</li>
        <li>當您使用本公司的多項服務時，若依據您的個資，如：電子郵件、姓名、手機等，經系統比對為同一人，我們將整合您的個人資料來進行處理。</li>
        <li>QuickPlan 網站使用第三方服務 Hotjar 提供的分析工具，用以瞭解使用者瀏覽 QuickPlan 網站的情況，包含於本網站內滑鼠點擊、移動、捲動視窗、及部分鍵盤輸入行為，所有搜集資料僅用作協助 QuickPlan 改進網站功能，並提供用戶更好的使用體驗，不會搜集任何密碼及涉及個人隱私的資料。蒐集資料將由 Hotjar 傳送並保存於 Hotjar 的伺服器。透過 Hotjar 追蹤代碼搜集的訊息包含：您瀏覽網站的設備 IP 位置（以匿名格式儲存及傳送）、設備螢幕尺寸、設備類型及瀏覽器、設備所在國家、網頁瀏覽使用的語言、使用域名、查看過的本站頁面、瀏覽時間。Hotjar 使用 Cookie 記錄無涉個人隱私訊息的資料，包含使用行為及裝置資料，用以提供使用者更好的體驗。 Hotjar 會使用其他第三方服務，含 Google Analytics 及 Optimizely。這些服務可能收集您的瀏覽器所傳送的 Cookie 或 IP 要求。如需了解 Google Analytics 及 Optimizely 如何收集和使用您個人資訊，請參閱其隱私權政策。 如需更詳細的資訊，請參閱 Hotjar 的隱私權政策 （https://www.hotjar.com/privacy）， 若您希望停止 Hotjar 的記錄功能，可至以下網址取消：<a href="https://www.hotjar.com/opt-out">https://www.hotjar.com/opt-out</a></li>
        </ul>
        <p><u>資料分享與揭露</u></p>
        <p>除非符合下列其中一種情況，否則我們不會與本公司以外的公司、機構或個人分享您的個人資訊：</p>
        <ul>
        <li>服務供應商：為了讓所有產品或服務能順利運作，我們會與雲端資訊服務供應商合作，包括：雲端運算與資料儲存平台、電子報發報系統等服務。</li>
        <li>合作夥伴： 為改善服務，我們會與第三方的數據分析服務合作，如：Google Analytics、Hotjar，提供您更優質的使用者體驗。</li>
        <li>公司所有權變更：若涉及公司（無論整體或部分）合併、銷售、收購、撤資、重組、改組、解散、破產或公司所有權或控制權的其他變更時，我們會在發布相關公告以及透過您留下的電子聯繫方式通知您後，移轉您的資訊。</li>
        <li>執法機關與資料保護主管機關：依據法律要求，在合理必要的情況下，我們可以披露您的資訊：</li>
        </ul>
        <ol>
        <li>為了遵守法律程序，例如法院命令、傳票或搜索票、配合政府/執法調查或其他法律要求。</li>
        <li>為了協助預防或偵查犯罪（每一個案依據適用法律）。</li>
        </ol>
        <ul>
        <li>為了保障任何人的安全。</li>
        </ul>
        <ol>
        <li>就非法活動、涉嫌詐騙或其他不法行為進行調查、採取預防措施或其他行動。</li>
        </ol>
        <p><u>隱私權政策更新</u></p>
        <p>QuickPlan 隱私權政策可能隨網站業務的需求隨時更改，除另有聲明者外，所有的修訂條款將於張貼日起自動生效，請定期查看。</p>
        <p><u>聯絡我們</u></p>
        <p>如果對本隱私權政策或我們的信息處理⽅法有任何疑問，請通過電⼦郵件的⽅式聯繫：QuickPlan＠onead.com.tw</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-checkbox class='dialog-footer-agree-checkbox' v-model="agree" :disabled="haveAuthorized">已閱讀並同意以上使用條款</el-checkbox>
        <el-button class='dialog-footer-agree-button' :type="buttonType" @click="confirmTerms" :disabled="!agree">確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import user from '@/api/user'
export default {
  props: {
    // 沒有傳入 visible 就會是 undefined
    // 在 AppSidebar 會傳入 visible props (點按控制 dialog 開關)
    // 在 Guide/Index.vue 不傳 visible props (頁面自動檢查不用外面控制)
    visible: {
      default: undefined
    }
  },
  watch: {
    visible: {
      handler () {
        this.setVisible()
      }
    },
    haveAuthorized: {
      handler () {
        this.setAgree()
      }
    }
  },
  computed: {
    haveAuthorized () {
      if (!this.$store.state.root.userInfo) return false
      return this.$store.state.root.userInfo.qp_authorization
    },
    buttonType () {
      if (this.agree) return 'primary'
      return 'info'
    }
  },
  data () {
    return {
      dialogVisible: false,
      agree: false
    }
  },
  created () {
    this.setVisible()
    this.setAgree()
  },
  methods: {
    setVisible () {
      // 沒有給 visible 時看有沒有確認過 terms，有給 visible 就是在 AppSidebar 這頁點按看 terms
      this.dialogVisible = this.visible === undefined ? !this.haveAuthorized : this.visible
    },
    setAgree () {
      this.agree = this.haveAuthorized
    },
    confirmTerms () {
      this.dialogVisible = false
      if (this.visible !== undefined) {
        this.dialogVisible = false
        // 更新父元件(AppSidebar) data 為 false
        this.$emit('update:visible', false)
        return
      }
      if (this.haveAuthorized) return
      user.authorizeTerms()
        .then(() => {
          this.$store.dispatch('root/updateTermsAuthorizationTrue')
          window.sessionStorage.setItem('qpUserInfo', JSON.stringify(this.$store.state.root.userInfo))
        })
        .catch(err => {
          this.$alert(`送出失敗 ${err}`)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .terms {
    /deep/ .termsDialog {
      max-width: 700px;
    }
    /deep/ .el-dialog__body {
      padding: 0px 20px;
    }
    /deep/ .el-dialog__footer {
      display:  flex;
      align-items: center;
      justify-content:  center;
      .dialog-footer {
        display:  flex;
        align-items: center;
        justify-content:  center;
        flex-direction: column;
        &-agree-checkbox {
          flex-basis: 100%;
        }
        &-agree-button {
          margin-top: 10px;
          flex-basis: 100%;
          width: 100px;
          height: 40px;
        }
      }
    }
    .termsContent {
      width:100%;
      height: 60vh;
      overflow-y: auto;
      line-height: 2.0;
      padding-right: 20px;
      padding-left: 20px;
    }
  }

</style>
